
const RightSticky = ({
    stickyText,
    stickyPosition,
    stickyBgColor,
}) => <div className="prompt-alert" style={{background: stickyBgColor}} data-mobile-alert={`${stickyPosition}-sticky`}>
<h5 className="regular mb-0">{stickyText}</h5>                                         
</div>

export default RightSticky;